import React, { useEffect, useState, Fragment } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { useParams } from 'react-router-dom';
import { wsGet } from 'services/WService';
import { FormControl, FormControlLabel, InputLabel, MenuItem, Paper, Radio, Select, TableContainer, TextField, Table, TableHead, TableCell, TableBody, TableRow } from '@material-ui/core';

function ViewPurchaseCreditNote() {
  const params = useParams();

  const [creditNote, setCreditNote] = useState({ lines: [] });

  useEffect(() => {
    getCreditNoteData();
  }, []);

  async function getCreditNoteData() {
    let res = await wsGet('purch/credit-note', params.id);
    setCreditNote(res.data);
  }

  return (<Fragment>
    <CardContainer title={"Nota de crédito compra " + params.id}>
      <GridContainer>
        {/* Tipo de nota crédito */}
        <GridItem xs={12}>
          <h5 style={{ margin: 0, fontWeight: 400 }}>Tipo de nota crédito</h5>
        </GridItem>
        <GridItem xs={12}>
          <FormControlLabel
            label="Mercadería"
            control={
              <Radio checked={creditNote.DocType === 'I'} />
            }
          />
          <FormControlLabel
            label="Servicio"
            control={
              <Radio checked={creditNote.DocType === 'S'} />
            }
          />
        </GridItem>
        {/* Documento de referencia */}
        <GridItem xs={12}>
          <GridContainer>
            <GridItem xs={12}>
              <h5 style={{ margin: 0, fontWeight: 400 }}>
                Documento de referencia
              </h5>
            </GridItem>
            <GridItem xs={12} md={4} lg={2}>
              <FormControl fullWidth margin="normal" size="small">
                <InputLabel shrink>Tipo documento</InputLabel>
                <Select
                  value={creditNote.U_SYP_MDTO || ''}
                  readOnly
                >
                  <MenuItem value="01">Factura</MenuItem>
                  <MenuItem value="03">Boleta</MenuItem>
                </Select>
              </FormControl>
            </GridItem>
            <GridItem xs={12} md={4} lg={2}>
              <TextField
                label="Serie"
                fullWidth
                name="U_SYP_MDSO"
                margin="normal"
                size="small"
                InputLabelProps={{
                  shrink: true,

                }}
                value={creditNote.U_SYP_MDSO || ''}
              />
            </GridItem>
            <GridItem xs={12} md={4} lg={2}>
              <TextField
                label="Código"
                fullWidth
                name="U_SYP_MDCO"
                margin="normal"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                value={(creditNote.U_SYP_MDCO || '').padStart(8, '0')}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
        {/* Nota de Crédito */}
        <GridItem xs={12} style={{ marginTop: '20px' }}>
          <GridContainer>
            <GridItem xs={12}>
              <h5 style={{ margin: 0, fontWeight: 400 }}>
                Nota de Crédito
              </h5>
            </GridItem>
            {/* Tipo documento */}
            <GridItem xs={12} md={4} lg={2}>
              <FormControl fullWidth margin="normal" size="small">
                <InputLabel shrink>Tipo documento</InputLabel>
                <Select
                  defaultValue=""
                  inputProps={{ name: 'U_SYP_MDTD' }}
                  value={creditNote.U_SYP_MDTD || ''}
                  required
                >
                  <MenuItem value="07">Nota de crédito</MenuItem>
                  <MenuItem value="03">Boleta</MenuItem>
                  <MenuItem value="01">Factura</MenuItem>
                </Select>
              </FormControl>
            </GridItem>
            {/* Serie */}
            <GridItem xs={12} md={4} lg={2}>
              <TextField
                label="Serie"
                fullWidth
                name="U_SYP_MDSD"
                margin="normal"
                size="small"
                required
                InputLabelProps={{
                  shrink: true,
                }}
                value={creditNote.U_SYP_MDSD || ''}
              />
            </GridItem>
            {/* Código */}
            <GridItem xs={12} md={4} lg={2}>
              <TextField
                label="Código"
                fullWidth
                name="U_SYP_MDCD"
                margin="normal"
                size="small"
                required
                InputLabelProps={{
                  shrink: true,
                }}
                value={creditNote.U_SYP_MDCD || ''}
              />
            </GridItem>
            {/* Almacén */}
            <GridItem xs={12} md={4} lg={2}>
              <TextField
                label="Almacén"
                fullWidth
                margin="normal"
                size="small"
                required
                InputLabelProps={{
                  shrink: true,
                }}
                value={creditNote.warehouse?.WhsName || ''}
              />
            </GridItem>
            {/* Proveedor */}
            {creditNote.DocType === 'S' && (
              <GridItem xs={12} md={4} lg={2}>
                <TextField
                  label="Proveedor"
                  fullWidth
                  margin="normal"
                  size="small"
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={creditNote.provider?.CardName || ''}
                />
              </GridItem>
            )}
            {/* DocDate Fecha Contable */}
            <GridItem xs={12} md={4} lg={2}>
              <TextField
                label="Fecha Contable"
                fullWidth
                name="DocDate"
                margin="normal"
                type="date"
                size="small"
                value={(creditNote.DocDate || '').split(' ')[0]}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{ readOnly: true }}
              />
            </GridItem>

            {/* TaxDate Fecha Documento Editable */}
            <GridItem xs={12} md={4} lg={2}>
              <TextField
                label="Fecha Documento"
                fullWidth
                name="TaxDate"
                margin="normal"
                type="date"
                size="small"
                required
                value={(creditNote.TaxDate || '').split(' ')[0]}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{ readOnly: true }}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </CardContainer>
    {creditNote.DocType === 'I' && (
      <TableContainer component={Paper}>
        <Table style={{ minWidth: 1300 }} size="small">
          <TableHead>
            <TableCell width="50" align="center">
              #
            </TableCell>
            <TableCell width="200" align="left">
              Código
            </TableCell>
            <TableCell align="left">Producto</TableCell>
            <TableCell align="left" width="100">UM</TableCell>
            <TableCell align="left" width="100">Cant. x Paq</TableCell>
            <TableCell align="left" width="130">
              Impuesto
            </TableCell>
            <TableCell align="left" width="130">
              Cantidad
            </TableCell>
            <TableCell align="left" width="130">
              Precio
            </TableCell>
            <TableCell align="left" width="130">
              Importe
            </TableCell>
          </TableHead>
          <TableBody>
            {creditNote.lines.map((row, index) => {
              return (
                <TableRow key={row.id}>
                  <TableCell>{parseInt(row.LineNum) + 1}</TableCell>
                  <TableCell>{row.ItemCode}</TableCell>
                  <TableCell>{row.Dscription}</TableCell>
                  <TableCell>{row.unitMsr}</TableCell>
                  <TableCell>{row.NumPerMsr}</TableCell>
                  <TableCell>{`${parseFloat(row.VatPrcnt).toFixed(2)}%`}</TableCell>
                  <TableCell>{row.Quantity}</TableCell>
                  <TableCell>{row.Price}</TableCell>
                  <TableCell>{row.GTotal}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    )}
    {creditNote.DocType === 'S' && (
      <TableContainer component={Paper}>
        <Table style={{ minWidth: 1300 }} size="small">
          <TableHead>
            <TableCell width="50" align="center">
              #
            </TableCell>
            <TableCell align="left">Producto</TableCell>
            <TableCell align="left" width="130">
              Impuesto
            </TableCell>
            <TableCell align="left" width="130">
              Cantidad
            </TableCell>
            <TableCell align="left" width="130">
              Precio
            </TableCell>
            <TableCell align="left" width="130">
              Importe
            </TableCell>
          </TableHead>
          <TableBody>
            {creditNote.lines.map((row, index) => {
              return (
                <TableRow key={row.id}>
                  <TableCell>{parseInt(row.LineNum) + 1}</TableCell>
                  <TableCell>{row.Dscription}</TableCell>
                  <TableCell>{`${parseFloat(row.VatPrcnt).toFixed(2)}%`}</TableCell>
                  <TableCell>{row.Quantity}</TableCell>
                  <TableCell>{row.Price}</TableCell>
                  <TableCell>{row.GTotal}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </Fragment>);
}

export default ViewPurchaseCreditNote;
